import GraphQLUploadPhotosDocument from "src/api/graphql/__generated__/documents/UploadPhotosWebDocument";
export default GraphQLUploadPhotosDocument;
